import Icon from "assets/icons";
import { useCopies } from "shared/hooks/useCopies";
import classNames from "classnames";
interface ParticipantNameProps {
  firstName?: string;
  lastName?: string;
  accessRequirement?: boolean;
  fullName?: string;
  className?: string;
  self?: boolean;
}
export function ParticipantName(props: ParticipantNameProps) {
  const copies = useCopies();
  return (
    <div className={classNames("participantName", props.className)}>
      <span className="participantName--text">
        {props.fullName ? props.fullName : `${props.firstName} ${props.lastName}`}
        {props.self && ` (${copies.get("me")})`}
      </span>
      {props.accessRequirement && (
        <span className="participantName--accessRequired" title={copies.get("accessibility.icon.title")}>
          <Icon.Accessibility className="accessRequired" />
        </span>
      )}
    </div>
  );
}
